import { MeetingModel } from "models/MeetingModel";
import { createContext } from "react";
import { TriggerEvent } from "react-contexify";

export interface MeetingsContextMenuContextProps {
  showContextMenu: (event: TriggerEvent, item: MeetingModel) => void;
}
export const MeetingsContextMenuContext = createContext({} as MeetingsContextMenuContextProps);
